import { render, staticRenderFns } from "./NewbornFilter.vue?vue&type=template&id=0267bf26&"
import script from "./NewbornFilter.vue?vue&type=script&lang=js&"
export * from "./NewbornFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports